import qual_text from './qual';
import aip_text from './aip';
import cm_text from './credit_mgmt';

export default {
  qual: qual_text,
  aip: aip_text,
  cm: cm_text,
};
